import {ComboboxGeneric} from "@/components/ui/combobox-generic";

import {shiftsService} from "../../services";
import {ShiftType} from "../../types";

type TypeOption = {
  value: ShiftType;
  label: string;
};

type ShiftManageTypeComboboxProps = {
  value: TypeOption[] | null;
  onChange: (value: TypeOption | TypeOption[] | null) => void;
};

const TYPE_OPTIONS = shiftsService.shiftTypes;

export function ShiftManageTypeCombobox({value, onChange}: ShiftManageTypeComboboxProps) {
  return (
    <ComboboxGeneric<TypeOption>
      multiple
      items={TYPE_OPTIONS}
      value={value ?? []}
      onChange={onChange}
      getItemKey={(item) => item.value}
      getItemLabel={(item) => item.label}
      isItemEqual={(item, selected) => item.value === selected?.value}
      placeholder="Select type"
      emptyMessage="No types found"
    />
  );
}
